<template>
  <el-pagination
    class='hb-pagination'
    background
    :page-sizes='[2,10,20,50,100, 200, 300, 400]'
    @current-change='pageChange'
    @size-change='sizeChange'
    :current-page='currentPage'
    :layout='layout'
    :page-size='pageSize'
    :total='total'
  ></el-pagination>
</template>

<script>
export default {
  name: "HB_PAGINATION",
  props: {
    //有删除操作的必须要传datalist,同时删除完重新查询不应再给page赋值，会在组件中自动判断
    datalist: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    layout: {
      type: String,
      default: "sizes,total, prev, pager, next, jumper"
    },
    cb: {
      type: Function
    }
  },
  methods: {
    pageChange(val) {
      this.$emit("update:currentPage", val);
      this.cb && this.cb();
    },
    sizeChange(val) {
      this.$emit("update:pageSize", val);
      this.cb && this.cb();
    }
  },
  watch: {
    datalist(val) {
      //处理有删除操作的分页，数据变化后处理
      //没有删除的午需
      if (val.length === 0) {
        if (this.total > 0) {
          if (this.currentPage > 1) {
            this.$emit("current-change", this.currentPage - 1);
          }
        }
      }
    }
  }
};
</script>

<style>
</style>
